//
//
//
//
//
//
//
//
//
//
//
//
//

import { getUserInfo, isWeiXin, system } from '@/util/const'
import { getQueryVariable } from '@/util/const'

export default {
  components: {

  },
  data () {
    return {
      openInBrowser: false,
      status: false,
      phoneNumber: '',
      loginShow: false,
      boxShow:false,
      tagHref: {
        series_update: 'openpage://3520',
        recommend_update: 'openpage://8600'
      },
      bg: this.$t('birthday.bg'),
      resultType: 2,
      isIos: system(),
      isWeiXin: isWeiXin(),

    }
  },
  created () {
    let from = getQueryVariable('from')
    if (from === "sms") {
      this.$http.clickRate('birthday_sms')
    }else {
      this.$http.clickRate('birthday_email')
    }
  },
  mounted () {

  },
  methods: {}
}



// WEBPACK FOOTER //
// ./src/page/birthday/home.vue